import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import FileUpload from './FileUpload'


const App=()=>{
    return (
        <div class="container">
            <FileUpload/>
        </div>
    )
}

export default App